import { graphql } from '@/graphql-setup'

export const INFO_CONTENT_QUERY = graphql(`
  query InfoContentQuery($page: String!, $language: String!) {
    infoContent(page: $page, language: $language) {
      id
      text
      videoUrl
      language
      page
    }
  }
`)

export const TagFragment = graphql(`
  fragment TagInfo on TagNode {
    id
    name
    color
    description
    scope
    createdAt
    issuesCount
    createdBy {
      id
      fullName
    }
  }
`)

export const ALL_TAGS_QUERY = graphql(
  `
    query AllTags($scope: TagScope) {
      allTags(scope: $scope) {
        edges {
          node {
            ...TagInfo
          }
        }
      }
    }
  `,
  [TagFragment]
)
